module.exports = __webpack_public_path__ + "static/media/info.f16215e1.svg";